export default {"src":"/_next/static/media/up-small--format.659847c6.svg","height":8,"width":12};